import { render } from "./EcoNomicimprovement.vue?vue&type=template&id=cd6d020c"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/EcoNomicimprovement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cd6d020c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cd6d020c', __exports__)) {
    api.reload('cd6d020c', __exports__)
  }
  
  module.hot.accept("./EcoNomicimprovement.vue?vue&type=template&id=cd6d020c", () => {
    api.rerender('cd6d020c', render)
  })

}


export default __exports__